(function ($) {
  $.fn.wsSizeSelection = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            this.resizeMenu();
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      let selectElement;
      let containerElement;
      const isWolkyCom = $('body').hasClass('site-wolky-com');
      let currentSystem = isWolkyCom ? 'us' : 'eu';

      const sizeMap = {
        '35': '4',
        '35.5': '5',
        '36': '5.5',
        '37': '6',
        '37.5': '6.5',
        '38': '7',
        '38.5': '7.5',
        '39': '8',
        '39.5': '8.5',
        '40': '9',
        '41': '10',
        '41.5': '10',
        '42': '11',
        '43': '12',
        '44': '12.5',
        '45': '13',
        '46': '14',
      };

      let bindEvents = function () {
        selectElement.change(function () {
          build();
        });

        $(document).bind('woocommerce_update_variation_values', function () {
          build();
        });

        if (isWolkyCom) {
          selectElement.closest('form').find('.toggle-size').click(function(e) {
            e.preventDefault();

            currentSystem = $(this).data('system');

            selectElement.closest('form').find('.toggle-size').removeClass('active');
            $(this).addClass('active');

            build();
          });
        }
      }

      let build = function () {
        if (containerElement === undefined) {
          containerElement = $('<div class="ws-size-selection">');
        }

        selectElement.find('option').each((index, el) => {
          const option = $(el);
          const optionValue = option.val();
          let optionText = option.text();

          if (optionValue === '') return;

          if (currentSystem === 'us' && sizeMap[optionText]) {
            optionText = sizeMap[optionText];
          }

          let optionElement = containerElement.find(`[data-value="${optionValue}"]`);

          if (optionElement.length === 0) {
            optionElement = $(`<div class="ws-size-selection-option" data-value="${optionValue}"></div>`);

            optionElement.click(function () {
              if ($(this).hasClass('disabled')) return;
              selectElement.val(optionValue);

              selectElement.trigger('change');
              selectElement.closest('form').trigger('check_variations');
            });
            containerElement.append(optionElement);
          }

          optionElement.text(optionText);
          optionElement.toggleClass('selected', selectElement.val() === optionValue);
          optionElement.toggleClass('disabled', option.is(':disabled'));
        });

        if (!$.contains(document, containerElement[0])) {
          selectElement.after(containerElement);
        }
      }

      let initialize = function (selectElementParameter) {
        selectElement = $(selectElementParameter);

        if (selectElement.data('ws-size-selection')) {
          console.warn('Trying to reinitialize the size selection for element. Skipping.', selectElement);
          return;
        }
        selectElement.data('ws-size-selection', this);

        build();
        bindEvents();
      }

      initialize(this);
    });
  };
})(jQuery);
